module.exports = __webpack_public_path__ + "static/media/intersection.9e6babdf.svg";